module.exports = __webpack_public_path__ + "img/85.975fe135.jpg";